import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

//http://localhost:3333/api
//https://api-f4cil.herokuapp.com/api
export default api;

export const apiGet = (route, object = null) =>
  new Promise((resolve, reject) => {
    api
      .get(`${route}`)
      .then((res) => {
        if (object) {
          const { object } = res.data;
          resolve(object);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        console.error("apiGet error:", err);
        reject(`Erro ao obter ${route}`);
      });
  });

export const apiGetInfo = (route, idParam, object = null) =>
  new Promise((resolve, reject) => {
    api
      .get(`${route}/${idParam}`)
      .then((res) => {
        console.log(object);
        console.log(res.data);
        if (object) {
          const { object } = res.data;
          resolve(object);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        console.error("apiGet error:", err);
        reject(`Erro ao obter ${route} com id ${idParam}`);
      });
  });

export const apiPost = (route, data, object = null) =>
  new Promise((resolve, reject) => {
    api
      .post(`${route}`, { ...data })
      .then((res) => {
        if (object) {
          const { object } = res.data;
          resolve(object);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        console.error("apiGet error:", err);
        reject(`Erro ao salvar os dados em ${route}`);
      });
  });

export const apiPut = (route, idParam, data, object = null) =>
  new Promise((resolve, reject) => {
    api
      .put(`${route}/${idParam}`, { ...data })
      .then((res) => {
        if (object) {
          const { object } = res.data;
          resolve(object);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        console.error("apiGet error:", err);
        reject(`Erro ao atualizar os dados em ${route}`);
      });
  });

export const apiDelete = (route, idParam, object = null) =>
  new Promise((resolve, reject) => {
    api
      .delete(`${route}}/${idParam}`)
      .then((res) => {
        if (object) {
          const { object } = res.data;
          resolve(object);
        } else {
          resolve(res.data);
        }
      })
      .catch((err) => {
        console.error("apiGet error:", err);
        reject(`Erro ao apagar os dados em ${route} com id ${idParam}`);
      });
  });
